import originAxios from 'axios'
import api from './api.js'

export default function axios(option) {
    if(!option.method) option.method = "post";
    return new Promise((resolve, reject) => {
		let baseURL = "";
		// if(process.env.NODE_ENV === 'development' && !option.baseUrl) baseURL = "";
		if(option.baseUrl) baseURL = api.base_url;
	    // 1.创建axios的实例
	    const instance = originAxios.create({
		    baseURL,
		    timeout: 0
	    });

	    // 配置请求和响应拦截
	    instance.interceptors.request.use(config => {
			let token = localStorage.getItem('token');	    
		    if(token) config.headers['Authorization'] = token;
		    return config
	    }, err => {
		    return err
	    })

	    instance.interceptors.response.use(response => {
		    return response.data
	    }, err => {
		    if (err && err.response) {
			    switch (err.response.status) {
				    case 400:
					    err.message = '请求错误'
					break
				    case 401:
					    err.message = '未授权的访问'
					break
			    }
		    }
		    return err
	    })

	    // 2.传入对象进行网络请求
	    instance(option).then(res => {
		    resolve(res)
	    }).catch(err => {
		    reject(err)
	    })
    })
}


// WEBPACK FOOTER //
// ./src/http/http.js